/**
 * The browser's own IANA zone and locale, for the signup payload.
 *
 * The server validates the zone and falls back (Hebrew / -IL locale → Israel,
 * otherwise UTC), so an empty object here is always a safe answer — a browser
 * whose Intl throws must still be able to create an account.
 */
export function browserZone(): { timezone?: string; locale?: string } {
  try {
    const { timeZone, locale } = Intl.DateTimeFormat().resolvedOptions();
    return {
      ...(typeof timeZone === 'string' && timeZone.length > 0 ? { timezone: timeZone } : {}),
      ...(typeof locale === 'string' && locale.length > 0 ? { locale } : {}),
    };
  } catch {
    return {};
  }
}

/** Every IANA zone this browser knows, for the workspace zone picker. */
export function supportedTimeZones(): string[] {
  const intl = Intl as unknown as { supportedValuesOf?: (key: string) => string[] };
  try {
    const zones = intl.supportedValuesOf?.('timeZone') ?? [];
    return zones.length > 0 ? zones : ['UTC', 'Asia/Jerusalem'];
  } catch {
    return ['UTC', 'Asia/Jerusalem'];
  }
}
